module.exports = __webpack_public_path__ + "static/media/(PQ) Verification Jul_Aug_Sep_2023.df63828d.xlsx";